import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import type { IRankedListTooltipRow } from "./types";

export const MAX_ROWS = 10;

interface IRankedListTooltipContentProps {
    leftHeader: string;
    rightHeader: string;
    rows: IRankedListTooltipRow[];
    automationName?: string;
}

export const RankedListTooltipContent: FC<IRankedListTooltipContentProps> = ({
    leftHeader,
    rightHeader,
    rows,
    automationName,
}) => (
    <Stack
        gap="8px"
        minWidth="240px"
        maxWidth="320px"
        data-automation={automationName}
    >
        <Flex
            justifyContent="space-between"
            gap="16px"
            padding="0 0 6px 0"
            borderBottom={`1px solid ${colorsPalettes.carbon[50]}`}
        >
            <Text
                fontVariant="captionTitle"
                color={colorsPalettes.carbon[200]}
            >
                {leftHeader}
            </Text>
            <Text
                fontVariant="captionTitle"
                color={colorsPalettes.carbon[200]}
            >
                {rightHeader}
            </Text>
        </Flex>
        <Stack gap="4px">
            {rows.slice(0, MAX_ROWS).map(({ leftValue, rightValue }, index) => (
                <Flex
                    key={`tooltip-row-${index}`}
                    justifyContent="space-between"
                    alignItems="center"
                    gap="16px"
                >
                    <Flex
                        flex="1"
                        minWidth="0"
                    >
                        <Text
                            fontVariant="tooltip"
                            color={colorsPalettes.carbon[0]}
                            overflow="hidden"
                            textOverflow="ellipsis"
                            whiteSpace="nowrap"
                        >
                            {leftValue}
                        </Text>
                    </Flex>
                    <Text
                        fontVariant="caption"
                        color={colorsPalettes.carbon[0]}
                    >
                        {rightValue}
                    </Text>
                </Flex>
            ))}
        </Stack>
    </Stack>
);
